import { VStack, Checkbox, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";

const SHIPMENT_OPTIONS = [
  { key: "0", label: "0%" },
  { key: "1-98", label: "1 — 98%" },
  { key: "50", label: "50%" },
  { key: "99", label: "99%" },
  { key: "100", label: "100%" },
];

const ShipmentPercentFilter = observer(() => {
  const { pageStore } = useStores();
  const filters = pageStore.order_shipment_percent_filters || {};

  const handleChange = (key) => (e) => {
    pageStore.setOrderShipmentPercentFilter(key, e.target.checked);
  };

  return (
    <VStack
      align="start"
      spacing={2}
      bg="#333"
      p={3}
      borderRadius="10px"
      width="250px"
      color="#EEEEEE"
    >
      <Text fontSize="14px" fontWeight="600">
        % отгрузки
      </Text>
      {SHIPMENT_OPTIONS.map((opt) => (
        <Checkbox
          key={opt.key}
          colorScheme="green"
          isChecked={!!filters[opt.key]}
          onChange={handleChange(opt.key)}
        >
          {opt.label}
        </Checkbox>
      ))}
    </VStack>
  );
});

export default ShipmentPercentFilter;
